import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from './../shared/shared.module';
import { DataExportsRoutingModule } from './data-exports-routing.module';
import { DataExportsComponent } from './data-exports.component';

@NgModule({
  declarations: [DataExportsComponent],
  imports: [CommonModule, SharedModule, DataExportsRoutingModule],
})
export class DataExportsModule {}
